import { render } from "./App.vue?vue&type=template&id=c92d65cc&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c92d65cc&scoped=true&lang=css"

import exportComponent from "/Users/alexvoina/Development/myhouse-admin-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92d65cc"]])

export default __exports__